import { config } from 'process';

const fs = require('fs');
var GeneticAlgorithmConstructor = require('geneticalgorithm')

var hash = require('object-hash');
var data = require('./data.json');
const populationSize = 50;
var courses = data;
const Days=7
const Hours=13
courses = courses.courses;


function HowMachHour(Data) {
    var FlagContent = [0, 0, 0];

    if (Data.lecture.length > 0) {

        FlagContent[0] += Hour_to_Number(Data.lecture[0].finishHour[0]) - Hour_to_Number(Data.lecture[0].startHour[0])
        if (Data.lecture[0].finishHour[1] != null)
            FlagContent[0] += Hour_to_Number(Data.lecture[0].finishHour[1]) - Hour_to_Number(Data.lecture[0].startHour[1])

    }

    if (Data.exercise.length > 0) {

        FlagContent[1] += Hour_to_Number(Data.exercise[0].finishHour[0]) - Hour_to_Number(Data.exercise[0].startHour[0])
        if (Data.exercise[0].finishHour[1] != null)
            FlagContent[1] += Hour_to_Number(Data.exercise[0].finishHour[1]) - Hour_to_Number(Data.exercise[0].startHour[1])

    }

    if (Data.lab.length > 0) {

        FlagContent[2] += Hour_to_Number(Data.lab[0].finishHour[0]) - Hour_to_Number(Data.lab[0].startHour[0])
        if (Data.lab[0].finishHour[1] != null)
            FlagContent[2] += Hour_to_Number(Data.lab[0].finishHour[1]) - Hour_to_Number(Data.lab[0].startHour[1])

    }

    return FlagContent[0] + FlagContent[1] + FlagContent[2]
}



function FillSchdule(Data, Schedule) {
    var i = 0;
    Data.day.forEach((value, i) => {
        if (value != null) {
            const startHour = Hour_to_Number(Data.startHour[i])
            const finishHour = Hour_to_Number(Data.finishHour[i])
            var dif = finishHour - startHour
          
            for (; dif > 0; dif--) {
                if (!IsEmpty(Day_to_Number(Data.day[i]), finishHour - dif, Schedule)) {
                    DeleteSchdule(Day_to_Number(Data.day[i]), finishHour - dif, Schedule);
                    Schedule.FlagChange++;

                }
                Schedule.data[Day_to_Number(Data.day[i])][finishHour - dif] = Data
                Schedule.BusyHours++;

            }
        }
    });
}
function Hour_to_Number(Hour) {
    if (Hour === null)
        return null;
    Hour = Hour.replace(/\s/g, '');
    switch (Hour) {
        case '08:30':
            return 0;
            break;
        case '09:30':
            return 1;
            break;
        case '10:30':
            return 2;
            break;
        case '11:30':
            return 3;
            break;
        case '12:20':
            return 4;
            break;
        case '12:50':
            return 4;
            break;
        case '13:50':
            return 5;
            break;
        case '14:50':
            return 6;
            break;
        case '15:50':
            return 7;
            break;
        case '16:50':
            return 8;
            break;
        case '17:50':
            return 9;
            break;
        case '18:50':
            return 10;
            break;
        case '19:50':
            return 11;
            break;
            case '20:50':
                return 12;
                break;
                case '21:50':
                    return 13;
                    break;
        default:
            return null;
            break;
    }
}
function Day_to_Number(day) {
    if (day === null)
        return null;
    day = day.replace(/\s/g, '');
    switch (day) {
        case 'א':
            return 0;
            break;
        case 'ב':
            return 1;
            break;
        case 'ג':
            return 2;
            break;
        case 'ד':
            return 3;
            break;
        case 'ה':
            return 4;
            break;
        case 'ו':
            return 5;
            break;
        case 'ז':
            return 6;
            break;
        default:
            return null;
            break;
    }
}
function DeleteSchdule(day, hour, Schedule) {


    Schedule.data[day][hour] = null

    Schedule.BusyHours--;
}

function DeleteById(Course_id, Schedule) {

    Schedule.data.forEach((day, i) => {
        var flag = 0;
        day.forEach((hour, j) => {
            if ((hour != null || hour != undefined) && hour.course_id == Course_id)
                DeleteSchdule(i, j, Schedule);

        })

    });

}
export function GetHtmlTabale(Schedule) {

    var cnt = 0;
    var cols = Days-1;

   
    var html = "";
    var arratDay = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"]
    var arrattimes = ["8:30", "9:30", "10:30", "11:30", "12:50", "13:50", "14:50", "15:50", "16:50", "17:50", "18:50", "19:50","20:50"]
    var rows = arrattimes.length-1;
    html += "<table style='  border: 1px solid black;'>"

    html += "<tr style='  border: 1px solid black;'><td style='  border: 1px solid black;'>" + "----" + "</td>"

    arratDay.forEach(value => {
        html += "<td style='  border: 1px solid black;'>" + value + "</td>"
    })
    html += "</tr>"
    for (var i = 0; i <= rows; i++) {
        html += "<tr style='  border: 1px solid black;' >";
        for (var h = -1; h <= cols; h++) {
            if (h == -1)
                html += "<td style='  border: 1px solid black;'>" + arrattimes[i] + '  </td>';
            else if (Schedule.data[h][i] != null || Schedule.data[h][i] != undefined) {
                html += "<td style='  border: 1px solid black;'>" + Schedule.data[h][i].course_name + " " + Schedule.data[h][i].Type + " " + Schedule.data[h][i].Lecturer + '  </td>';
                cnt++;
            }
            else
                html += "<td style='  border: 1px solid black;'>" + "------" + '</td>';
        }
        html += '</tr>';
    }
    html += "<table>"
    html += "<div style=' color: blue; textAlign:'right';'>שעות:" + cnt + "</div>"
    html += "<div style=' color: blue; textAlign:'right';'>ימים:" + (Days - fitnessFunctionEmptyDays(Schedule)) + "</div>"
    html += "<div style=' color: blue; textAlign:'right';'>חלונות:" + (Days*Hours - fitnessFunctionEmptyHour(Schedule)) + "</div>"

    return html;
}

function IsEmpty(day, hour, Schedule) {
    return Schedule.data[day][hour] === null ? true : false;

}

function FillListOfCoursesRandomly(Courses, Schedule) {
    restSchdule(Schedule);
    var trys = 200;
    do {
        trys--
        restSchdule(Schedule);

        Courses.forEach((value) => {

            var res = ChoiceOneEachType(value);
            res.forEach((window) => {
                FillSchdule(window, Schedule);
            });
        });

    } while (Schedule.FlagChange != 0 && trys > 0);




}

function restSchdule(Schedule) {
    Schedule.BusyHours = 0
    Schedule.FlagChange = 0
    Schedule.data = [[], [], [], [], [], [], [], []]
    Schedule.data.forEach(value => {
        for (var i = 0; i <= Hours; i++)
            value.push(null);
    });
    return 1;
}

function init_Schdule() {

    const Schedule = {








        HowMachWindowIsFull: () => {
            var count = 0;
            for (var i = 0; i <= Days; i++) {
                for (var j = 0; i <= Hours; j++) {
                    if (Schedule.Isfill(i, j) === true)
                        count++;
                }
            }
        }
        ,
        BusyHours: 0,
        FlagChange: 0,
        data: [[], [], [], [], [], [], [], []]
    }

    return Schedule;

}

function TypeOfContent(course) {

    var FlagContent = [0, 0, 0];
    if (course.lecture.length > 0)
        FlagContent[0] = 1;
    if (course.exercise.length > 0)
        FlagContent[1] = 1;
    if (course.lab.length > 0)
        FlagContent[2] = 1;
    return FlagContent;

};

function ChoiceOneEachType(data, flags = TypeOfContent(data)) {
    const coursesToFill = [];
    if (flags[0] === 1) {
        coursesToFill.push({ ...data.lecture[Math.floor(Math.random() * data.lecture.length)], Type: 'הרצאה', course_name: data.course_name, course_id: data.course_id });
    }
    if (flags[1] === 1) {
        coursesToFill.push({ ...data.exercise[Math.floor(Math.random() * data.exercise.length)], Type: 'תרגול', course_name: data.course_name, course_id: data.course_id });
    }
    if (flags[2] === 1) {
        coursesToFill.push({ ...data.lab[Math.floor(Math.random() * data.lab.length)], Type: 'מעבדה', course_name: data.course_name, course_id: data.course_id });
    }
    return coursesToFill;
}
export function fitnessFunctionEmptyDays(phenotype) {
    var fitness = 7;
    phenotype.data.forEach(day => {
        var flag = 0;
        day.forEach(hour => {
            if (hour != null || hour != undefined)

                flag = 1;
        })
        if (flag === 1) {
            fitness--;
        }
    }
    )
    var total = 0;
    courses.forEach(course => {
        total += HowMachHour(course);
    });
    if (total != phenotype.BusyHours)
        fitness = 0;


    return fitness;
}

export function fitnessFunctionEmptyHour(phenotype) {
    var fitness = Days*Hours;
    phenotype.data.forEach(day => {
        var flagISeeAclass = 0;
        var count =0;
        day.forEach(hour => {
            if (hour != null || hour != undefined) {
                flagISeeAclass=1;
                    if(count>0)
                    {
                        fitness-=count;
                        count=0;
                    }
            }
            else {
                
                if(flagISeeAclass===1)
                count++
            }
        })
    }
    )
    var total=0;
    courses.forEach(course => {
        total+=HowMachHour(course);
    });
if(total!=phenotype.BusyHours)
fitness=0;
    return fitness;
}




function mutationFunction(oldPhenotype) {

    var VecIndexs = []

    oldPhenotype.data.forEach((day, i) => {
        var flag = 0;
        day.forEach((hour, j) => {
            if (hour != null || hour != undefined)

                VecIndexs.push({ i, j });
        })

    });

    var WhatDelete = VecIndexs[Math.floor(Math.random() * VecIndexs.length)];
    var course_to_retake = oldPhenotype.data[WhatDelete.i][WhatDelete.j].course_id;
    DeleteById(course_to_retake, oldPhenotype);
    courses.forEach(value => {
        if (value.course_id == course_to_retake) {
            var trys = 0;
            do {
                trys++;
                var res = ChoiceOneEachType(value);
                var flagIsFill = 0
                res.forEach(window => {
                    if (!IsEmpty(Day_to_Number(window.day[0]), Hour_to_Number(window.startHour[0]), oldPhenotype))
                        flagIsFill = 1;

                })

            } while (flagIsFill && trys < 10);
            if (trys != 10)
                res.forEach((window) => {

                    FillSchdule(window, oldPhenotype);
                });
            else
                FillListOfCoursesRandomly(courses, oldPhenotype)
        }
    });
    return oldPhenotype
}

function createEmptyPhenotype(Size) {
    var array = [];
    var Schedule;
    for (; Size > 0; Size--) {
        Schedule = init_Schdule();
        FillListOfCoursesRandomly(courses, Schedule)
        array.push(Schedule);
    }

    return array;
}



function GetListOfSameScore(arr, Phenotype, fitnessFunction) {
    const arrayOfresult = [Phenotype];
    arr.forEach((value) => {
        var flag = 1
        arrayOfresult.forEach((arrayOfresultvalue) => {



            if (hash.sha1(arrayOfresultvalue) === hash.sha1(value.phenotype)) {
                flag = 0;
            }

        });
        if (value.score == fitnessFunction(Phenotype) && flag === 1)
            arrayOfresult.push(value.phenotype);

    })




    return arrayOfresult
}


export function InitGa(Data,fitFunction) {

    courses = Data.courses;
    var config = {
        mutationFunction: mutationFunction,
        // crossoverFunction: yourCrossoverFunction,
        fitnessFunction: fitnessFunctionEmptyDays,
        //  doesABeatBFunction: yourCompetitionFunction,
        population: createEmptyPhenotype(populationSize),
        populationSize: populationSize 	// defaults to 100
    }

config.fitnessFunction=fitFunction;
    var ga = GeneticAlgorithmConstructor(config)
    for (var i = 0; i < populationSize; i++) {

        ga.evolve();
    }

    var scoreList = ga.scoredPopulation()
    scoreList = GetListOfSameScore(scoreList, ga.best(), config.fitnessFunction);


    if (ga.bestScore() === 0)
        return "<div>Cant Build</div>"
    return scoreList;

}